
import React, { Component } from "react";
import Config from "../../../config";
import { message, Modal, Button, Select, Input, Radio, Checkbox,Tooltip } from "antd";
import { tsDateToThaiDate } from "../../../utils/func";
import Datetimepicker from "../../jquery/datetimepicker";
import _ from "underscore";
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const TextArea = Input.TextArea;

const ListDisable = [
  { STEP_C: "1", SEQ: "0100", data: [], 2: ["ก.1"], 3: ["ข.1"] },
  { STEP_C: "1", SEQ: "0200", data: ["3"], 2: ["ก.1"], 3: [] },
  { STEP_C: "1", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "1", SEQ: "0400", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "1", SEQ: "0500", data: ["1", "2", "3"], 2: [], 3: [] },

  { STEP_C: "2", SEQ: "0100", data: [], 2: ["ก.2"], 3: ["ข.2"] },
  { STEP_C: "2", SEQ: "0200", data: ["2"], 2: [], 3: [] },

  { STEP_C: "3", SEQ: "0100", data: [], 2: ["ก.3"], 3: ["ข.1"] },
  { STEP_C: "3", SEQ: "0200", data: [], 2: ["ก.3"], 3: ["ข.2"] },
  { STEP_C: "3", SEQ: "0300", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "3", SEQ: "0400", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "4", SEQ: "0100", data: ["3"], 2: ["ก.3"], 3: [] },
  { STEP_C: "4", SEQ: "0200", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "4", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0500", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0600", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "4", SEQ: "0700", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "5", SEQ: "0100", data: ["3"], 2: ["ก.4"], 3: [] },
  { STEP_C: "5", SEQ: "0200", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "5", SEQ: "0300", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "5", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.3"] },
  { STEP_C: "5", SEQ: "0500", data: ["2"], 2: [], 3: ["ข.3"] },
  { STEP_C: "5", SEQ: "0600", data: ["3"], 2: ["ก.4",/*"ก.3"*/], 3: [] },
  { STEP_C: "5", SEQ: "0700", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "5", SEQ: "0800", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "6", SEQ: "0100", data: ["3"], 2: ["ก.5"], 3: [] },
  { STEP_C: "6", SEQ: "0200", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "6", SEQ: "0300", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "6", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "6", SEQ: "0500", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "7", SEQ: "0100", data: ["3"], 2: ["ก.6"], 3: [] },
  { STEP_C: "7", SEQ: "0200", data: [], 2: ["ก.6", "ก.7"], 3: ["ข.1", "ข.4"] },
  { STEP_C: "7", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "7", SEQ: "0400", data: ["2", "3"], 2: [], 3: [] },

    { STEP_C: "8", SEQ: "0100", data: [], 2: ["ก.6(1)", "ก.6(2)"], 3: ["ข.2"] },
  { STEP_C: "8", SEQ: "0200", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0300", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0400", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0500", data: ["1", "2", "3"], 2: [], 3: [] }
];
console.log('m2', ListDisable)





class Xpage6ef04dc09 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ListDisable: ListDisable,
      modeLayout1: false,
      modeLayout2: false,
      modeLayout3: false,
      data1: [],
      data2: [],
      data3: {},
      data4Master: [],
      data5Master: [],
      data4: [],
      data5: [],
      data6: [],
      visible2: false,
      visible3: false,
      audit_energy_used: [],
      audit_sec_electric: [],
      audit_sec_heat: [],
      audit_sec_service: [],
      audit_sec: [],
      audit_save: [],
      m2: {},
      visible4: false,
      visible5: false,
      visible6: false,
      m4: {} ,
      m5: {},
      m5: {} ,
      MACHINE:[],
      data431Master:[],
      data432Master:[]
    };

    let { year, plt_bld_id, time } = this.props;
    setTimeout(() => {
      this.getDataLayoutAll(year, plt_bld_id, time);
    }, 50);

    //   this.getDisableList = this.getDisableList.bind(this);
  }

  getDataLayoutAll(year, plt_bld_id, time) {
    let { step } = this.props;
    this.getDataLayout1(year, plt_bld_id);
    this.getDataLayout2Auto(year, plt_bld_id);
    // this.getDataLayout2(year ,plt_bld_id)
    this.getDataLayout3(year, plt_bld_id);

    if ([4].indexOf(step) > -1) {
      this.getDataLayout4Master()
      this.getDataLayout4(year, plt_bld_id)
      this.getDataLayout43_1Master();
      this.getDataLayout43_2Master();
    }

    if ([5].indexOf(step) > -1) {
      this.getDataLayout5Master()
      this.getDataLayout5(year, plt_bld_id)
    }

    if ([6].indexOf(step) > -1) {
      this.getDataLayout5Master()
      this.getDataLayout6(year, plt_bld_id)
      this.getDataLayout43_1Master();
      this.getDataLayout43_2Master();
    }
    

   
    if ([4, 5, 6].indexOf(step) > -1) {
      this.getExtraRowALl(year, plt_bld_id);
    }
  }

  getDataLayout1(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc09-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            this.setState({
              modeLayout1: "view",
              data1: data.data ? data.data : []
            });
          }
          console.log("getData1", data);
        },
        err => {
          console.log("getData1", err);
        }
      );
  }

  getDataLayout2(year, plt_bld_id) {
    let { step } = this.props;
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc09-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&step=${step}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data && data.data.length > 0) {
            this.setState({ modeLayout2: "view", data2: data.data });
          }
          console.log("getData2", data);
        },
        err => {
          console.log("getData2", err);
        }
      );
  }

  getDataLayout2Auto(year, plt_bld_id) {
    let { step } = this.props;
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc09-l2-auto?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&step=${step}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          this.getDataLayout2(year, plt_bld_id);
          // if (data.resultCode == 20000 && data.data && data.data.length > 0) {
          //     this.setState({ modeLayout2: 'view', data2: data.data });
          // }
          console.log("getData2-auto", data);
        },
        err => {
          console.log("getData2-auto", err);
        }
      );
  }

  getDataLayout3(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc09-l3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            this.setState({ modeLayout3: "view", data3: data.data[0] });
          }
          console.log("getData3", data);
        },
        err => {
          console.log("getData3", err);
        }
      );
  }

  getDataLayout4(year, plt_bld_id) {
    let {  time } = this.props
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l4?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let no = 1;
            let _data =  data.data.map(r=>{
              r.no = no
              no = no + 1
              return r
            })
            this.setState({ data4: _data });
          }

        },
        err => {

        }
      );
  }

  getDataLayout5(year, plt_bld_id) {
    let { time } = this.props
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l5?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let no = 1;
            let _data = data.data.map(r => {
              r.no = no
              no = no + 1
              return r
            })
            this.setState({ data5: _data });
          }

        },
        err => {

        }
      );
  }

  getDataLayout6(year, plt_bld_id) {
    let { time } = this.props
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l6?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let no = 1;
            let _data = data.data.map(r => {
              r.no = no
              no = no + 1
              return r
            })
            this.setState({ data6: _data });
          }

        },
        err => {

        }
      );
  }

  getDataLayout43_1Master() {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l43-1-master?token=${token}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let dddd = _.groupBy(data.data ? data.data : [], 'SYSTEM_NAME')
            let ddddd = []
            for (let i in dddd) {
              ddddd.push({ 'SYSTEM_NAME': i })
            }
            this.setState({ data431Master: ddddd });
          }
          console.log("getdata4Master", data);
        },
        err => {
          console.log("getdata4Master", err);
        }
      );
  }

  getDataLayout43_2Master() {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l43-2-master?token=${token}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let dddd = _.groupBy(data.data ? data.data : [], 'SYSTEM_NAME')
            let ddddd = []
            for(let i in dddd){
              ddddd.push({'SYSTEM_NAME':i})
            }
            this.setState({ data432Master: ddddd});
          }
          console.log("getdata4Master", data);
        },
        err => {
          console.log("getdata4Master", err);
        }
      );
  }

  getDataLayout4Master() {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l4-master?token=${token}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            this.setState({ data4Master: data.data });
          }
          console.log("getdata4Master", data);
        },
        err => {
          console.log("getdata4Master", err);
        }
      );
  }

  getDataLayout5Master() {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc09-l5-master?token=${token}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            let no = 1;
            let _data = data.data.map(r => {
              r.no = no
              no = no + 1
              return r
            })
            this.setState({ data5Master: _data });
          }
          console.log("getdata4Master", data);
        },
        err => {
          console.log("getdata4Master", err);
        }
      );
  }

  putDataLayout2() {
    let { m2 } = this.state;
    let temp = this.getArrayDisable(m2.STEP_C, m2.SEQ);
    let v_l = false;
    if (temp && temp.length > 0) {
      temp = temp[0];
      let EXTRA_ARRAY = m2.EXTRA_ARRAY ? m2.EXTRA_ARRAY : [];
      if (m2.PASS_FLAG === "2" || m2.PASS_FLAG === "3") {
        if (temp[m2.PASS_FLAG] && temp[m2.PASS_FLAG].length > 0) {
          let t = temp[m2.PASS_FLAG].find(r => EXTRA_ARRAY.indexOf(r) > -1);
          if (!t) {
            v_l = true;
            console.log(t);
            message.error("กรุณาเลือกข้อมูลให้ครบ");
          }
        }
      }
    }
    if (v_l) {
      return;
    }

    let { step, plt_bld_id, year, time } = this.props;
    let token = localStorage.getItem("ef_token");

    m2.EXTRA = m2.EXTRA_ARRAY ? m2.EXTRA_ARRAY.reverse().join(",") : "";

    let data = { ...m2, token, step, plt_bld_id, year, time };
    console.log("data", data);
    return fetch(Config.api + `/api/putReport-ef04dc09-l2`, {
      method: "PUT", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(
        data => {
          console.log(data.resultCode);
          if (data.resultCode == 20000) {
            let { year, plt_bld_id } = this.props;

            this.getDataLayout2(year, plt_bld_id);
            this.setState({ visible2: false, m2: {} });
          } else {
            alert("error");
          }
        },
        () => {
          alert("error");
        }
      );
  }

  putDataLayout4() {
    let { step, plt_bld_id, year, time } = this.props
    let token = localStorage.getItem("ef_token");
    let { data4 } = this.state
    let data = { data:data4, token, step, plt_bld_id, year, time }
    console.log('data', data)
    return fetch(Config.api + `/api/putReport-ef04dc09-l4`, {
      method: 'PUT', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then((data) => {
        console.log(data.resultCode)
        if (data.resultCode == 20000) {
          let { year, plt_bld_id } = this.props
          this.getDataLayout4(year, plt_bld_id)
          this.setState({ visible4: false, m4: [] })
        } else {
          alert('error')
        }
      }, () => {
        alert('error')
      });
  }

  putDataLayout5() {
    let { step, plt_bld_id, year, time } = this.props
    let token = localStorage.getItem("ef_token");
    let { data5 } = this.state
    let data = { data: data5, token, step, plt_bld_id, year, time }
    console.log('data', data)
    return fetch(Config.api + `/api/putReport-ef04dc09-l5`, {
      method: 'PUT', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then((data) => {
        console.log(data.resultCode)
        if (data.resultCode == 20000) {
          let { year, plt_bld_id } = this.props
          this.getDataLayout5(year, plt_bld_id)
          this.setState({ visible5: false, m5: {} })
        } else {
          alert('error')
        }
      }, () => {
        alert('error')
      });
  }

  putDataLayout6() {
    let { step, plt_bld_id, year, time } = this.props
    let token = localStorage.getItem("ef_token");
    let { data6 } = this.state
    let data = { data: data6, token, step, plt_bld_id, year, time }
    console.log('data', data)
    return fetch(Config.api + `/api/putReport-ef04dc09-l6`, {
      method: 'PUT', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then((data) => {
        console.log(data.resultCode)
        if (data.resultCode == 20000) {
          let { year, plt_bld_id } = this.props
          this.getDataLayout6(year, plt_bld_id)
          this.setState({ visible6: false, m6: {} })
        } else {
          alert('error')
        }
      }, () => {
        alert('error')
      });
  }

  Layout1() {
    let { data1 } = this.state;
    let { year, plt_bld_id } = this.props;
    return (
      <div>
        <h1>
          แบบกำหนดความรับผิดชอบในการตรวจสอบและรับรองการจัดการพลังงานตามข้อกำหนดวิธีการจดการพลังงานประจำปี{" "}
          {this.props.year}
        </h1>
        <table style={{ borderSpacing: "1px 1px" }}>
          {data1.map(r => {
            return (
              <tbody>
                <tr>
                  <td>
                    <b>ชื่อนิติบุคคลที่ถูกตรวจสอบ : </b>
                    {r.JURISTIC_NAME}
                    <b>ประจำปี : </b>
                    {year}
                    <b>ครั้งที่ : </b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>ขื่อ{r.TYPE}."ควบคุม ที่ถูกตรวจสอบ : </b>
                    {r.PLT_BLD_NAME}
                    <b>TSIC-ID : </b>
                    {r.TSIC_ID}
                    <b>วันที่ : </b>
                    {r.PROCEED_D}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>ชื่อผู้ตรวจสอบ : </b>
                    {r.ORGANIZE_NAME}
                  </td>
                </tr>
              </tbody>
            );
          })}
        </table>
      </div>
    );
  }

  // getDisableList(STEP_C, SEQ){

  //     console.log(STEP_C, SEQ, ListDisable);
  // }

  getIsDisable(STEP_C, SEQ, col) {
    return (
      this.state.ListDisable.filter(
        r => r.STEP_C === STEP_C && r.SEQ === SEQ && r.data.indexOf(col) > -1
      ).length > 0
    );
  }

  getArrayDisable(STEP_C, SEQ) {
    return this.state.ListDisable.filter(
      r => r.STEP_C === STEP_C && r.SEQ === SEQ
    );
  }
  putDataLayout2Extra(item) {
    let token = localStorage.getItem("ef_token");
    let { year, plt_bld_id, time, step } = this.props;
    if ([4, 5, 6].indexOf(step) > -1) {
      let {
        audit_energy_used,
        audit_sec_electric,
        audit_sec_heat,
        audit_sec_service,
        audit_sec,
        audit_save
      } = this.state;
      let data = { year, plt_bld_id, time, step, token, data: { audit_energy_used: [audit_energy_used], audit_sec_electric, audit_sec_heat, audit_sec_service, audit_sec: [audit_sec], audit_save}};
      // console.log("data", data);
      return fetch(Config.api + `/api/getReport-ef04dc09-extra`, {
        method: "PUT", // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => response.json())
        .then(
          data => {
            this.getExtraRowALl(year, plt_bld_id);
          },
          () => {
            this.getExtraRowALl(year, plt_bld_id);
          }
        );
      //
    }
  }
  getExtraRowALl(year, plt_bld_id) {
    let { step } = this.props;
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc09-extra?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&step=${step}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          // this.getDataLayout2(year, plt_bld_id);
          if (data.resultCode == 20000 && data.data) {
            let {
              audit_energy_used,
              audit_sec_electric,
              audit_sec_heat,
              audit_sec_service,
              audit_sec,
              audit_save
            } = data.data;
            console.log("====================================");
            console.log(data.data);
            console.log("====================================");
            if (audit_energy_used.length > 0){
              audit_energy_used = audit_energy_used[0];
            }else{
              audit_energy_used = {
                plt_bld_id: plt_bld_id,
                year: year,
                type: step === 4 || step === 5 ? "ref" :"real",
                electric_used: "",
                heat_used: "",
                all_used: ""
              };
            }

            if (audit_sec.length > 0) {
              audit_sec = audit_sec[0];
            } else {
              audit_sec = {
                plt_bld_id: plt_bld_id,
                year: year,
                percent_save: "",
                type: step === 4 || step === 5 ? "plan" : "real"
              };
            }
            

            this.setState({
              audit_energy_used: audit_energy_used,
              audit_sec_electric: audit_sec_electric,
              audit_sec_heat: audit_sec_heat,
              audit_sec_service: audit_sec_service,
              audit_sec: audit_sec,
              audit_save: audit_save
            });
          }
          console.log("getData2-auto", data);
        },
        err => {
          console.log("getData2-auto", err);
        }
      );
  }

  isExtraRow(item, m2) {
    if (
      (item.STEP_C === "4" && item.SEQ === "0300") ||
      (item.STEP_C === "4" && item.SEQ === "0400") ||
      (item.STEP_C === "5" && item.SEQ === "0100") ||
      (item.STEP_C === "6" && item.SEQ === "0100")
    ) {
      return true;
    } else {
      return false;
    }
  }

  extraRow(item, m2) {
    let { year, plt_bld_id } = this.props;

    let {
      audit_energy_used,
      audit_sec_electric,
      audit_sec_heat,
      audit_sec_service,
      audit_sec,
      audit_save
    } = this.state;
    //r.SEQ != m2.SEQ
    if (item.STEP_C === "4" && item.SEQ === "0300" && item.SEQ === m2.SEQ) {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> ข้อมูลการใช้พลังงาน (ปีฐาน*) </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      ปี {year} <br />- การใช้พลังงานไฟฟ้า{" "}
                      <NumericInput
                        value={audit_energy_used.electric_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.electric_used = e
                          //   e.target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      kWh/ปี
                      <br />- การใช้พลังงานความร้อน{" "}
                      <NumericInput
                        value={audit_energy_used.heat_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.heat_used = e
                          // .target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      MJ/ปี
                      <br />
                      {/* * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน */}
                      <br />
                    </div>
                  </td>
                  <td>
                    <div>
                      {/* * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน */}
                      <br />
                      การใช้พลังงานรวม
                      <br />-
                      <NumericInput
                        value={audit_energy_used.all_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.all_used = e
                          // .target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      MJ/ปี
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>* ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน</div>
                  </td>
                </tr>
                

                <tr>
                  <td>
                    <div>สัดส่วนการใช้พลังงานไฟฟ้า</div>
                  </td>
                  <td>
                    <div>สัดส่วนการใช้พลังงานความร้อน</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {audit_sec_electric.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -{/* {r.sec_name} */}
                              <Select
                                name=""
                                className=""
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].sec_name =
                                    e;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                defaultValue=""
                                value={audit_sec_electric[i].sec_name}
                                style={{ width: 300 }}
                              >
                                <Option value="">----กรุณาเลือก----</Option>
                                {this.state.data431Master.map(r => {
                                  return <Option value={r.SYSTEM_NAME}>{r.SYSTEM_NAME}</Option>;
                                })}
                              </Select>
                              {/* <Input
                                type="textbox"
                                value={audit_sec_electric[i].sec_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].sec_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              /> */}
                            </span><br/>
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_sec_electric[i].kwh_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].kwh_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.kwh_per_year}  */}
                              kWh/ปี{" "}
                            </span>
                            <span>
                              ร้อยละ
                              <NumericInput
                                type="textbox"
                                value={audit_sec_electric[i].percent}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].percent =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.percent} */}
                            </span>
                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let {
                                      audit_sec_electric
                                    } = this.state;
                                    audit_sec_electric = audit_sec_electric.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_electric: audit_sec_electric
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_electric.reduce((s,r)=>{
                          return s + (r.kwh_per_year ? r.kwh_per_year:0);
                        },0)} kWh/ปี </span>
                        <span>ร้อยละ{audit_sec_electric.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                      </div>
                      <div>
                        <span />
                        <span />
                        <span>
                          <Button
                            key="back"
                            onClick={() => {
                              let { audit_sec_electric } = this.state;
                              audit_sec_electric.push({
                                plt_bld_id: plt_bld_id,
                                year: year,
                                sec_name: "",
                                kwh_per_year: "",
                                percent: "",
                                type: "ref"
                              });
                              this.setState({
                                audit_sec_electric: audit_sec_electric
                              });
                            }}
                          >
                            เพิ่ม
                          </Button>
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      {audit_sec_heat.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                              <Select
                                name=""
                                className=""
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].system_name =
                                    e;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                defaultValue=""
                                value={audit_sec_electric[i].sec_name}
                                style={{width:300}}
                              >
                                <Option value="">----กรุณาเลือก----</Option>
                                {this.state.data432Master.map(r => {
                                  return <Option value={r.SYSTEM_NAME}>{r.SYSTEM_NAME}</Option>;
                                })}
                              </Select>
                              {/* <Input
                                type="textbox"
                                value={audit_sec_heat[i].system_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].system_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              /> */}
                     
                            </span><br />
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_sec_heat[i].mj_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].mj_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.mj_per_year} */}
                              MJ/ปี
                            </span>
                            <span>
                              ร้อยละ
                              <NumericInput
                                type="textbox"
                                value={audit_sec_heat[i].percent}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].percent =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.percent} */}
                            </span>

                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let { audit_sec_heat } = this.state;
                                    audit_sec_heat = audit_sec_heat.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_heat: audit_sec_heat
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_heat.reduce((s, r) => {
                          return s + (r.mj_per_year ? parseFloat(r.mj_per_year) : 0);
                        }, 0)}MJ/ปี</span>
                        <span>ร้อยละ{audit_sec_heat.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                      </div>

                      <div>
                        <span />
                        <span />
                        <span>
                          <Button
                            key="back"
                            onClick={() => {
                              let { audit_sec_heat } = this.state;
                              audit_sec_heat.push({
                                plt_bld_id: plt_bld_id,
                                year: year,
                                system_name: "",
                                mj_per_year: "",
                                percent: "",
                                type: "ref"
                              });
                              this.setState({
                                audit_sec_heat: audit_sec_heat
                              });
                            }}
                          >
                            เพิ่ม
                          </Button>
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else if (
      item.STEP_C === "4" &&
      item.SEQ === "0400" &&
      item.SEQ === m2.SEQ
    ) {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">ค่าการใช้พลังงานจำเพาะ (ปีฐาน)</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>
                      {audit_sec_service.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                              <Input
                                type="textbox"
                                value={audit_sec_service[i].service_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_service } = this.state;
                                  audit_sec_service[i].service_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_service: audit_sec_service
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.service_name} */}
                            </span>
                            <span>
                              {" "}
                              <NumericInput
                                type="textbox"
                                value={audit_sec_service[i].mj_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_service } = this.state;
                                  audit_sec_service[i].mj_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_service: audit_sec_service
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.kwh_per_year} */}
                              MJ/หน่วย{" "}
                            </span>
                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let { audit_sec_service } = this.state;
                                    audit_sec_service = audit_sec_service.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_service: audit_sec_service
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                            {/* <span>ร้อยละ {r.percent}</span> */}
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <span />
                      <span />
                      <span>
                        <Button
                          key="back"
                          onClick={() => {
                            let { audit_sec_service } = this.state;
                            audit_sec_service.push({
                              plt_bld_id: plt_bld_id,
                              year: year,
                              service_name: "",
                              mj_per_year: "",
                              percent: "",
                              type: "ref"
                            });
                            this.setState({
                              audit_sec_service: audit_sec_service
                            });
                          }}
                        >
                          เพิ่ม
                        </Button>
                      </span>
                    </div>
                  </td>
                  {/* <td /> */}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else if (
      item.STEP_C === "5" &&
      item.SEQ === "0100" &&
      item.SEQ === m2.SEQ
    ) {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ padding: 0 }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> เป้าหมายผลประหยัด</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    - ร้อยละของพลังงานที่ประสงค์จะให้ลดลง*{" "}
                    {/* {audit_sec.percent_save} */}
                    <NumericInput
                      value={audit_sec.percent_save}
                      size="80"
                      maxlength="500"
                      onChange={e => {
                        console.log(e);
                        let { audit_sec } = this.state;
                        audit_sec.percent_save = e
                        // .target.value;
                        this.setState({
                          audit_sec: audit_sec
                        });
                      }}
                      style={{ width: "200px" }}
                    />
                    <br />* คิดเทียบกับการใช้พลังงานรวมของปีฐาน
                  </td>
                  <td>
                    <div>
                      {audit_save.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                              <Input
                                type="textbox"
                                value={audit_save[i].sec_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_save } = this.state;
                                  audit_save[i].sec_name = e.target.value;
                                  this.setState({
                                    audit_save: audit_save
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.sec_name} */}
                            </span>
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_save[i].mj_per_unit}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_save } = this.state;
                                  audit_save[i].mj_per_unit =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_save: audit_save
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.mj_per_unit} */}
                              MJ/หน่วย
                            </span>

                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let { audit_save } = this.state;
                                    audit_save = audit_save.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_save: audit_save
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <span />
                      <span />
                      <span>
                        <Button
                          key="back"
                          onClick={() => {
                            let { audit_save } = this.state;
                            audit_save.push({
                              plt_bld_id: plt_bld_id,
                              year: year,
                              sec_name: "",
                              mj_per_unit: "",
                              type: "plan"
                            });
                            this.setState({ audit_save: audit_save });
                          }}
                        >
                          เพิ่ม
                        </Button>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else if (
      item.STEP_C === "6" &&
      item.SEQ === "0100" &&
      item.SEQ === m2.SEQ
    ) {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> ข้อมูลการใช้พลังงาน (ปีฐาน*) </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      ปี {year} <br />- การใช้พลังงานไฟฟ้า{" "}
                      <NumericInput
                        value={audit_energy_used.electric_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.electric_used =
                            e
                            // .target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      kWh/ปี
                      <br />- การใช้พลังงานความร้อน{" "}
                      <NumericInput
                        value={audit_energy_used.heat_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.heat_used = e
                          // .target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      MJ/ปี
                      <br />
                      * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน
                      <br />
                    </div>
                  </td>
                  <td>
                    <div>
                      * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน
                      <br />
                      การใช้พลังงานรวม
                      <br />-
                      <NumericInput
                        value={audit_energy_used.all_used}
                        size="80"
                        maxlength="500"
                        onChange={e => {
                          console.log(e);
                          let { audit_energy_used } = this.state;
                          audit_energy_used.all_used = e
                          // .target.value;
                          this.setState({
                            audit_energy_used: audit_energy_used
                          });
                        }}
                        style={{ width: "200px" }}
                      />{" "}
                      MJ/ปี
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>สัดส่วนการใช้พลังงานไฟฟ้า</div>
                  </td>
                  <td>
                    <div>สัดส่วนการใช้พลังงานความร้อน</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {audit_sec_electric.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -{/* {r.sec_name} */}
                              <Select
                                name=""
                                className=""
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].sec_name =
                                    e;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                defaultValue=""
                                value={audit_sec_electric[i].sec_name }
                                style={{ width: 300 }}
                              >
                                <Option value="">----กรุณาเลือก----</Option>
                                {this.state.data431Master.map(r => {
                                  return <Option value={r.SYSTEM_NAME}>{r.SYSTEM_NAME}</Option>;
                                })}
                              </Select>
                              {/* <Input
                                type="textbox"
                                value={audit_sec_electric[i].sec_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].sec_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              /> */}
                            </span><br />
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_sec_electric[i].kwh_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].kwh_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.kwh_per_year}  */}
                              kWh/ปี{" "}
                            </span>
                            <span>
                              ร้อยละ
                              <NumericInput
                                type="textbox"
                                value={audit_sec_electric[i].percent}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_electric } = this.state;
                                  audit_sec_electric[i].percent =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_electric: audit_sec_electric
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.percent} */}
                            </span>
                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let {
                                      audit_sec_electric
                                    } = this.state;
                                    audit_sec_electric = audit_sec_electric.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_electric: audit_sec_electric
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_electric.reduce((s, r) => {
                          return s + (r.kwh_per_year ? parseFloat(r.kwh_per_year) : 0);
                        }, 0)} kWh/ปี </span>
                        <span>ร้อยละ{audit_sec_electric.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                      </div>
                      <div>
                        <span />
                        <span />
                        <span>
                          <Button
                            key="back"
                            onClick={() => {
                              let { audit_sec_electric } = this.state;
                              audit_sec_electric.push({
                                plt_bld_id: plt_bld_id,
                                year: year,
                                sec_name: "",
                                kwh_per_year: "",
                                percent: "",
                                type: "real"
                              });
                              this.setState({
                                audit_sec_electric: audit_sec_electric
                              });
                            }}
                          >
                            เพิ่ม
                          </Button>
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      {audit_sec_heat.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                              <Select
                                name=""
                                className=""
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].system_name =
                                    e;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                defaultValue=""
                                value={audit_sec_heat[i].system_name}
                                style={{ width: 300 }}
                              >
                                <Option value="">----กรุณาเลือก----</Option>
                                {this.state.data432Master.map(r => {
                                  return <Option value={r.SYSTEM_NAME}>{r.SYSTEM_NAME}</Option>;
                                })}
                              </Select>
                              {/* <Input
                                type="textbox"
                                value={audit_sec_heat[i].system_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].system_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              /> */}
                              {/* {r.system_name} */}
                            </span><br />
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_sec_heat[i].mj_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].mj_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.mj_per_year} */}
                              MJ/ปี
                            </span>
                            <span>
                              ร้อยละ
                              <NumericInput
                                type="textbox"
                                value={audit_sec_heat[i].percent}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_heat } = this.state;
                                  audit_sec_heat[i].percent =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_heat: audit_sec_heat
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.percent} */}
                            </span>

                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let { audit_sec_heat } = this.state;
                                    audit_sec_heat = audit_sec_heat.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_heat: audit_sec_heat
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_heat.reduce((s, r) => {
                          return s + (r.mj_per_year ? parseFloat(r.mj_per_year) : 0);
                        }, 0)}  MJ/ปี </span>
                        <span>ร้อยละ{audit_sec_heat.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                      </div>

                      <div>
                        <span />
                        <span />
                        <span>
                          <Button
                            key="back"
                            onClick={() => {
                              let { audit_sec_heat } = this.state;
                              audit_sec_heat.push({
                                plt_bld_id: plt_bld_id,
                                year: year,
                                system_name: "",
                                mj_per_year: "",
                                percent: "",
                                type: "real"
                              });
                              this.setState({
                                audit_sec_heat: audit_sec_heat
                              });
                            }}
                          >
                            เพิ่ม
                          </Button>
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">ค่าการใช้พลังงานจำเพาะ (ปีฐาน)</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>
                      {audit_sec_service.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                              
                              <Input
                                type="textbox"
                                value={audit_sec_service[i].service_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_service } = this.state;
                                  audit_sec_service[i].service_name =
                                    e.target.value;
                                  this.setState({
                                    audit_sec_service: audit_sec_service
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.service_name} */}
                            </span>
                            <span>
                              {" "}
                              <NumericInput
                                type="textbox"
                                value={audit_sec_service[i].mj_per_year}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_sec_service } = this.state;
                                  audit_sec_service[i].mj_per_year =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_sec_service: audit_sec_service
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.kwh_per_year} */}
                              MJ/หน่วย{" "}
                            </span>
                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let {
                                      audit_sec_service
                                    } = this.state;
                                    audit_sec_service = audit_sec_service.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_sec_service: audit_sec_service
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                            {/* <span>ร้อยละ {r.percent}</span> */}
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <span />
                      <span />
                      <span>
                        <Button
                          key="back"
                          onClick={() => {
                            let { audit_sec_service } = this.state;
                            audit_sec_service.push({
                              plt_bld_id: plt_bld_id,
                              year: year,
                              service_name: "",
                              mj_per_year: "",
                              percent: "",
                              type: "real"
                            });
                            this.setState({
                              audit_sec_service: audit_sec_service
                            });
                          }}
                        >
                          เพิ่ม
                        </Button>
                      </span>
                    </div>
                  </td>
                  {/* <td /> */}
                </tr>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> เป้าหมายผลประหยัด</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    - ร้อยละของพลังงานที่ประสงค์จะให้ลดลง*{" "}
                    {/* {audit_sec.percent_save} */}
                    <NumericInput
                      value={audit_sec.percent_save}
                      size="80"
                      maxlength="500"
                      onChange={e => {
                        console.log(e);
                        let { audit_sec } = this.state;
                        audit_sec.percent_save = e
                        // .target.value;
                        this.setState({
                          audit_sec: audit_sec
                        });
                      }}
                      style={{ width: "200px" }}
                    />
                    <br />* คิดเทียบกับการใช้พลังงานรวมของปีฐาน
                  </td>
                  <td>
                    <div>
                      {audit_save.map((r, i) => {
                        return (
                          <div>
                            <span>
                              -
                               
                              <Input
                                type="textbox"
                                value={audit_save[i].sec_name}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_save } = this.state;
                                  audit_save[i].sec_name = e.target.value;
                                  this.setState({
                                    audit_save: audit_save
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.sec_name} */}
                            </span>
                            <span>
                              <NumericInput
                                type="textbox"
                                value={audit_save[i].mj_per_unit}
                                size="200"
                                maxlength="200"
                                onChange={e => {
                                  let { audit_save } = this.state;
                                  audit_save[i].mj_per_unit =
                                    e
                                    // .target.value;
                                  this.setState({
                                    audit_save: audit_save
                                  });
                                }}
                                style={{ width: "100px" }}
                              />
                              {/* {r.mj_per_unit} */}
                              MJ/หน่วย
                            </span>

                            <span>
                              <Button
                                key="back"
                                onClick={() => {
                                  if (window.confirm("คุณต้องการลบ?")) {
                                    let { audit_save } = this.state;
                                    audit_save = audit_save.filter(
                                      (r, ii) => ii != i
                                    );
                                    this.setState({
                                      audit_save: audit_save
                                    });
                                  }
                                }}
                              >
                                ลบ
                              </Button>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <span />
                      <span />
                      <span>
                        <Button
                          key="back"
                          onClick={() => {
                            let { audit_save } = this.state;
                            audit_save.push({
                              plt_bld_id: plt_bld_id,
                              year: year,
                              sec_name: "",
                              mj_per_unit: "",
                              type: "real"
                            });
                            this.setState({ audit_save: audit_save });
                          }}
                        >
                          เพิ่ม
                        </Button>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else if (item.STEP_C === "4" && item.SEQ === "0300") {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> ข้อมูลการใช้พลังงาน (ปีฐาน*) </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      ปี {year} <br />- การใช้พลังงานไฟฟ้า{" "}
                      {audit_energy_used.electric_used} kWh/ปี
                      <br />- การใช้พลังงานความร้อน{" "}
                      {audit_energy_used.heat_used} MJ/ปี
                      <br />
                      {/* * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน */}
                      <br />
                    </div>
                  </td>
                  <td>
                    <div>
                      {/* * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน */}
                      <br />
                      การใช้พลังงานรวม
                      <br />- {audit_energy_used.all_used} MJ/ปี
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>* ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>สัดส่วนการใช้พลังงานไฟฟ้า</div>
                  </td>
                  <td>
                    <div>สัดส่วนการใช้พลังงานความร้อน</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {audit_sec_electric.map(r => {
                        return (
                          <div>
                            <span>- {r.sec_name}</span>
                            <span>{r.kwh_per_year} kWh/ปี </span>
                            <span>ร้อยละ {r.percent}</span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_electric.reduce((s, r) => {
                          return s + (r.kwh_per_year ? parseFloat(r.kwh_per_year) : 0);
                        }, 0)} kWh/ปี </span>
                        <span>ร้อยละ{audit_sec_electric.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      {audit_sec_heat.map(r => {
                        return (
                          <div>
                            <span>- {r.system_name}</span>
                            <span>{r.mj_per_year} MJ/ปี</span>
                            <span>ร้อยละ {r.percent}</span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>{audit_sec_heat.reduce((s, r) => {
                          return s + (r.mj_per_year ? parseFloat(r.mj_per_year) : 0);
                        }, 0)} MJ/ปี </span>
                        <span>ร้อยละ{audit_sec_heat.reduce((s, r) => {
                          return s + (r.percent ? parseFloat(r.percent) : 0);
                        }, 0)}</span>
                        {/* <span>รวม</span>
                        <span>MJ/ปี</span>
                        <span>ร้อยละ</span> */}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else if (item.STEP_C === "4" && item.SEQ === "0400") {
      return (
        <tr>
          {/* <td colSpan="1" /> */}

          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">ค่าการใช้พลังงานจำเพาะ (ปีฐาน)</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>
                      {audit_sec_service.map(r => {
                        return (
                          <div>
                            <span>- {r.service_name}</span>
                            <span> {r.mj_per_year} MJ/หน่วย </span>
                            {/* <span>ร้อยละ {r.percent}</span> */}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  {/* <td /> */}
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else if (item.STEP_C === "5" && item.SEQ === "0100") {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ padding: 0 }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> เป้าหมายผลประหยัด</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    - ร้อยละของพลังงานที่ประสงค์จะให้ลดลง*{" "}
                    {audit_sec.percent_save} <br />*
                    คิดเทียบกับการใช้พลังงานรวมของปีฐาน
                  </td>
                  <td>
                    <div>
                      {audit_save.map(r => {
                        return (
                          <div>
                            <span>- {r.sec_name}</span>
                            <span>{r.mj_per_unit} MJ/หน่วย</span>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else if (item.STEP_C === "6" && item.SEQ === "0100") {
      return (
        <tr>
          {/* <td colSpan="1" /> */}
          <td colSpan="6" style={{ padding: 0 }}>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> ข้อมูลการใช้พลังงาน (ปีฐาน*) </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      ปี {year} <br />- การใช้พลังงานไฟฟ้า{" "}
                      {audit_energy_used.electric_used} kWh/ปี
                      <br />- การใช้พลังงานความร้อน{" "}
                      {audit_energy_used.heat_used}MJ/ปี
                      <br />
                      * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน
                      <br />
                    </div>
                  </td>
                  <td>
                    <div>
                      * ปีก่อนหน้าปีที่ดำเนินการจัดการพลังงาน
                      <br />
                      การใช้พลังงานรวม
                      <br />- {audit_energy_used.all_used}
                      MJ/ปี
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>สัดส่วนการใช้พลังงานไฟฟ้า</div>
                  </td>
                  <td>
                    <div>สัดส่วนการใช้พลังงานความร้อน</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {audit_sec_electric.map(r => {
                        return (
                          <div>
                            <span>- {r.sec_name}</span>
                            <span>{r.kwh_per_year} kWh/ปี </span>
                            <span>ร้อยละ {r.percent}</span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>kWh/ปี</span>
                        <span>ร้อยละ</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      {audit_sec_heat.map(r => {
                        return (
                          <div>
                            <span>- {r.system_name}</span>
                            <span>{r.mj_per_year} MJ/ปี</span>
                            <span>ร้อยละ {r.percent}</span>
                          </div>
                        );
                      })}
                      <div>
                        <span>รวม</span>
                        <span>MJ/ปี</span>
                        <span>ร้อยละ</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">ค่าการใช้พลังงานจำเพาะ (ปีฐาน)</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div>
                      {audit_sec_service.map(r => {
                        return (
                          <div>
                            <span>- {r.service_name}</span>
                            <span>
                              {" "}
                              MJ/หน่วย{r.kwh_per_year} MJ/หน่วย{" "}
                            </span>
                            {/* <span>ร้อยละ {r.percent}</span> */}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  {/* <td /> */}
                </tr>
                <tr>
                  <td colSpan="2">
                    {" "}
                    <div> เป้าหมายผลประหยัด</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    - ร้อยละของพลังงานที่ประสงค์จะให้ลดลง*{" "}
                    {audit_sec.percent_save} <br />*
                    คิดเทียบกับการใช้พลังงานรวมของปีฐาน
                  </td>
                  <td>
                    <div>
                      {audit_save.map(r => {
                        return (
                          <div>
                            <span>- {r.sec_name}</span>
                            <span>{r.mj_per_unit} MJ/หน่วย</span>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {/* <td /> */}
        </tr>
      );
    } else {
      return null;
    }
  }

  Layout2() {
    let { data1, data2, data3, m2, data4, data5, data6 } = this.state;

    let data4_1 = data4.filter(r=>r.TYPE === 'E');
    let data4_2 = data4.filter(r => r.TYPE === 'H');
    let no = 1;
    let data5_1 = data5.filter(r => r.TYPE === 'E').map(r=>{
      r.no_ = no ;
      no = no +1;
      return r
    });
    no = 1;
    let data5_2 = data5.filter(r => r.TYPE === 'H').map(r => {
      r.no_ = no;
      no = no + 1;
      return r
    });
    no = 1;
    let data6_1 = data6.filter(r => r.TYPE === 'E').map(r => {
      r.no_ = no;
      no = no + 1;
      return r
    });
    no = 1;
    let data6_2 = data6.filter(r => r.TYPE === 'H').map(r => {
      r.no_ = no;
      no = no + 1;
      return r
    });
    return (
      <div>
        <table style={{ borderSpacing: "1px 1px" }}>
          {/* <tbody> */}
          <tr>
            <th rowSpan="3" style={{ width: "350px", textAlign: "center" }}>
              รายการประเมิน
            </th>
            <th colSpan="2" style={{ textAlign: "center" }}>
              ผลการประเมิน
            </th>
            <th colSpan="3" style={{ textAlign: "center" }}>
              ความสอดคล้อง
            </th>
            <th rowSpan="3" style={{ textAlign: "center" }}>
              ข้อคิดเห็นการปรับปรังวิธีการดำเนินการจัดการพลังงาน
            </th>
            <th rowSpan="3" style={{ width: "85px", textAlign: "center" }}>
              &nbsp;
            </th>
          </tr>
          <tr>
            <th rowSpan="2" style={{ width: "200px", textAlign: "center" }}>
              ชื่อรายละเอียดของหลักฐานที่ตรวจพบ
            </th>
            <th rowSpan="2" style={{ width: "60px", textAlign: "center" }}>
              ไม่มี/ไม่ พบหลักฐาน
            </th>
            <th rowSpan="2" style={{ width: "60px", textAlign: "center" }}>
              สอดคล้อง กับข้อกำหนด
            </th>
            <th colSpan="2" style={{ width: "120px", textAlign: "center" }}>
              ไม่สอดคล้องกับข้อกำหนด
            </th>
          </tr>
          <tr>
            <th style={{ width: "60px", textAlign: "center" }}>
              ประเภท ร้ายแรง
            </th>
            <th style={{ width: "60px", textAlign: "center" }}>
              ประเภท ไม่ร้ายแรง
            </th>
          </tr>
          {data2.map(r => {
            let temp = this.getArrayDisable(r.STEP_C, r.SEQ);
            let obj = {};
            let mode = 1;
            if (temp && temp.length > 0) {
              obj = temp[0];
              if (r.PASS_FLAG === "2" || r.PASS_FLAG === "3")
                if (obj[r.PASS_FLAG].length > 0) {
                  mode = 2;
                }
            }
            return (
              <tbody>
                {r.SEQ != m2.SEQ ? (
                  <tr
                    style={{
                      display:
                        r.SUB_STEP_DESC &&
                        r.SUB_STEP_DESC !== "" &&
                        r.SUB_STEP_DESC !== null
                          ? "contents"
                          : "none"
                    }}
                  >
                    <td
                      style={{ width: "80px" }}
                      rowSpan={this.isExtraRow(r, m2) ? "2" : "1"}
                    >
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{ __html: r.SUB_STEP_DESC }}
                      />
                    </td>
                    <td style={{ height: 70 }}>{r.EVIDENCE_DESC} </td>
                    <td style={{ textAlign: "center" }}>
                      {r.EVIDENCE_FLAG && r.EVIDENCE_FLAG == "1" ? (
                        <img src="images/icorrect.png" />
                      ) : null}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, "1")
                          ? "#ddd"
                          : "#fff"
                      }}
                    >
                      {r.PASS_FLAG == "1" ? (
                        <img src="images/icorrect.png" />
                      ) : null}
                      {/* {r.PASS_FLAG == '1' ? <div>{r.EXTRA}</div>:null} */}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, "2")
                          ? "#ddd"
                          : "#fff"
                      }}
                    >
                      {r.PASS_FLAG == "2" && mode == 1 ? (
                        <img src="images/icorrect.png" />
                      ) : null}
                      {r.PASS_FLAG == "2" && mode == 2 ? (
                        <div>{r.EXTRA}</div>
                      ) : null}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, "3")
                          ? "#ddd"
                          : "#fff"
                      }}
                    >
                      {r.PASS_FLAG == "3" && mode == 1 ? (
                        <img src="images/icorrect.png" />
                      ) : null}
                      {r.PASS_FLAG == "3" && mode == 2 ? (
                        <div>{r.EXTRA}</div>
                      ) : null}
                    </td>
                    <td>{r.NOTE}</td>
                    <td rowSpan={this.isExtraRow(r, m2) ? "2" : "1"}>
                      {r.SUB_STEP_DESC &&
                      r.SUB_STEP_DESC !== "" &&
                      r.SUB_STEP_DESC !== null ? (
                        <div>
                          <span
                            style={{ display: "block", textAlign: "right" }}
                          >
                            <ul className="myNavigation">
                              <li>
                                <button
                                  type="button"
                                  className="myButton1"
                                  style={{
                                    verticalAlign: "top",
                                    height: "32px"
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      visible2: true,
                                      m2: {
                                        ...r,
                                        EVIDENCE_FLAG: r.EVIDENCE_FLAG
                                          ? r.EVIDENCE_FLAG
                                          : "",
                                        EXTRA_ARRAY: r.EXTRA
                                          ? r.EXTRA.split(",")
                                          : []
                                      }
                                    });
                                  }}
                                >
                                  <img src="images/iPencil.png" />
                                  &nbsp;แก้ไข
                                </button>
                              </li>
                            </ul>
                          </span>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td
                      style={{ width: "80px" }}
                      rowSpan={this.isExtraRow(r, m2) ? "2" : "1"}
                    >
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{ __html: r.SUB_STEP_DESC }}
                      />
                    </td>
                    <td style={{ textAlign: "center" }} colSpan="6">
                      <div>{this.TRLayout2()} </div>
                    </td>
                    <td rowSpan={this.isExtraRow(r, m2) ? "2" : "1"}>
                      {r.SUB_STEP_DESC &&
                      r.SUB_STEP_DESC !== "" &&
                      r.SUB_STEP_DESC !== null ? (
                        <div>
                          <Button
                            key="back"
                            onClick={() => {
                              this.setState({ visible2: false, m2: {} });
                              let { year, plt_bld_id, time, step } = this.props;
                              if ([4, 5, 6].indexOf(step) > -1) {
                                this.getExtraRowALl(year, plt_bld_id);
                              }
                            }}
                          >
                            ปิด
                          </Button>
                          <Button
                            key="submit"
                            type="primary"
                            loading={false}
                            onClick={() => {
                              this.putDataLayout2();
                              this.putDataLayout2Extra(r);
                            }}
                          >
                            บันทึกข้อมูล
                          </Button>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                )}
                {this.extraRow(r, m2)}
      
              </tbody>
            );
          })}

          {/* </tbody> */}
        </table>


        {
                  this.props.step === 4 ?
                        <div style={{ minHeight: 150, padding: 8 }}>
                          <h1>รายละเอียดเครื่องจักรอุปกรณ์ที่มีนัยสำคัญ </h1>
                          <h1>ด้านไฟฟ้า</h1>
                          <table style={{ borderSpacing: "1px 1px" }}>
                                <tr>
                                  <th  rowSpan="2" style={{ width: "350px", textAlign: "center" }}>
                                    ระบบ
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                    ชื่อเครื่องจักร /อุปกรณ์หลัก
                                  </th>
                                  <th   colSpan="2" style={{ textAlign: "center" }}>
                                    พิกัด (Nameplate)
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                  จำนวน
                                  </th>
                                  <th   rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                  อายุการใช้งาน (ปี)
                                  </th>
                                  <th  rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                  ชั่วโมงใช้งานเฉลี่ย/ปี
                                  </th>
                                  <th  rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                    ปริมาณการใช้พลังงานไฟฟ้า (กิโลวัตต์-ชั่วโมง/ปี)
                                  </th>
                                  <th  rowSpan="2"style={{ width: "100px", textAlign: "center" }}>
                                    % การใช้พลังงานเทียบกับการใช้พลังงานรวม(รวมทั้งไฟฟ้าและความร้อน)
                                  </th>
                                  <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                    
                                  </th>
                             </tr>
                      <tr>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        ขนาด
                      </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        หน่วย
                       </th>
                    </tr>
              {
                data4_1.map((d, i) => {
                 return <tr>
                  <td style={{ textAlign: "center" }}>
                   &nbsp;{d.SYSTEM}
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.MACHINE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.MACHINE_SIZE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.UNIT_DESC }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.NUM }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.AGE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.WORK_HR }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.YEAR_USED }
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.PERCENT_USED}
                  </td>
                   <td style={{ textAlign: "center" }}>
                     <button type="button" class="ant-btn"
                       onClick={() => {
                         this.setState({ visible4: true, m4: { TYPE: 'E', action: 'edit', ...d }, MACHINE: this.state.data4Master.filter(r => d.SYSTEM_C === r.SYSTEM_C) });
                       }}><span>แก้ไข</span></button>
                                <button type="button" class="ant-btn" onClick={() => {
                                  let { data4, m4 } = this.state;
                                  data4 = data4.filter(r => r.no !== d.no)

                                  this.setState({ data4: data4 })
                                  setTimeout(() => {
                                    this.putDataLayout4();
                                  }, 50);
                                
                                }}><span>ลบ</span></button>
                  </td>

                  </tr>
                })

              }
                   </table>
                          <span style={{ display: "block", textAlign: "right" }}>
                            <ul className="myNavigation">
                              <li>
                                <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                                  let { data4, m4} = this.state;
                                    data4 = data4.filter(r => r.action !== 'create' && r.TYPE)
  
                                  this.setState({data4: data4 })

                                 
                                 this.setState({ visible4: true, m4: { TYPE: 'E', action: 'create' } , MACHINE: []});
                                }}>
                                  <img src="images/iPencil.png" />
                                  &nbsp;เพิ่ม
                            </button>
                              </li>
                            </ul>
                          </span>
                          <h1>ด้านความร้อน</h1>
                          <table style={{ borderSpacing: "1px 1px" }}>
                                <tr>
                                  <th  rowSpan="2" style={{ width: "350px", textAlign: "center" }}>
                                    ระบบ
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                    ชื่อเครื่องจักร /อุปกรณ์หลัก
                                  </th>
                                  <th   colSpan="2" style={{ textAlign: "center" }}>
                                    พิกัด (Nameplate)
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                  จำนวน
                                  </th>
                                  <th   rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                  อายุการใช้งาน (ปี)
                                  </th>
                                  <th  rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                  ชั่วโมงใช้งานเฉลี่ย/ปี
                                  </th>
                                  <th  rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                    ปริมาณการใช้ พลังงานไฟฟ้า (กิโลวัตต์-ชั่วโมง/ปี)
                                  </th>
                                  <th  rowSpan="2"style={{ width: "100px", textAlign: "center" }}>
                                  % การใช้พลังงานเทียบกับการใช้พลังงานรวม(รวมทั้งไฟฟ้าและความร้อน)
                                  </th>
                                  <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>

                                  </th>
                             </tr>
                      <tr>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        ขนาด
                      </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        หน่วย
                       </th>
                    </tr>

                  {
                data4_2.map((d, i) => {
                 return <tr>
                  <td style={{ textAlign: "center" }}>
                   &nbsp;{d.SYSTEM}
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.MACHINE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.MACHINE_SIZE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.UNIT_DESC }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.NUM }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.AGE }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.WORK_HR }
                  </td>
                  <td style={{ textAlign: "center" }}>
                      { d.YEAR_USED }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.PERCENT_USED }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     <button type="button" class="ant-btn"
                       onClick={() => {
                         
                 

                         this.setState({ visible4: true, m4: {  TYPE: 'H', action: 'edit',...d }, MACHINE: this.state.data4Master.filter(r => d.SYSTEM_C === r.SYSTEM_C) });
                                  }}><span>แก้ไข</span></button>
                     <button type="button" class="ant-btn"
                     onClick={()=>{
                      let { data4, m4 } = this.state;
                      data4 = data4.filter(r=>r.no!==d.no)
                      this.setState({data4:data4})
                        setTimeout(() => {
                          this.putDataLayout4();
                        }, 50);
                     }}><span>ลบ</span></button>
                  </td>


                  </tr>
                })
              }
                   </table>
                      <span style={{ display: "block", textAlign: "right" }}>
                            <ul className="myNavigation">
                            <li>
                            <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                                      let { data4, m4} = this.state;
                                    data4 = data4.filter(r => r.action !== 'create' && r.TYPE)
  
                                  this.setState({data4: data4 })

                                  this.setState({ visible4: true, m4: { TYPE: 'H', action: 'create' }, MACHINE: [] });
                              }}>
                              <img src="images/iPencil.png" />
                              &nbsp;เพิ่ม
                            </button>
                          </li>
                    </ul>
                  </span>
                 </div>
                  :null
                }




          {
                  this.props.step === 5 ?
                        <div style={{ minHeight: 150, padding: 8 }}>
                          {/* <h1>รายละเอียดเครื่องจักรอุปกรณ์ที่มีนัยสำคัญ </h1> */}
                          <h1>รายละเอียดแผนอนุรักษ์พลังงานด้านไฟฟ้า </h1>
                      <table style={{ borderSpacing: "1px 1px" }}>
                      <tr>
                        <th rowSpan="2" style={{ width: "70px", textAlign: "center" }}>
                          ลำดับที่
                                  </th>
                        <th rowSpan="2" style={{ textAlign: "center" }}>
                          ชื่อมาตรการ
                                  </th>
                        <th colSpan="3" style={{ textAlign: "center" }}>
                          เป้าหมายผลประหยัด
                                  </th>
                        <th rowSpan="2" style={{ textAlign: "center" }}>
                          เงินลงทุน (บาท)
                                  </th>
                        <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                          ร้อยละผลประหยัด
                         (คิดเทียบกับการใช้พลังงานรวมของปีฐาน)
                                  </th>
                        <th colSpan="2" style={{ width: "100px", textAlign: "center" }}>
                          ระยะเวลาดำเนินการ
                                  </th>
                        <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>

                        </th>
                      </tr>
                      <tr>
                        <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          kW
                      </th>
                        <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                         kWh/ปี
                       </th>
                        <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                         บาท/ปี
                       </th>
                        <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          เริ่มต้น
                       </th>
                        <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          สิ้นสุด
                       </th>
                      </tr>
              {
                data5_1.map((d, i) => {
                 return <tr>
                  <td style={{ textAlign: "center" }}>
                     &nbsp;{d.no_}
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.MEASURE_TDESC }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.KW }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.KWH }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.BAHT_PER_YR1 }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.INSTRUMENT }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.RETURN }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.START_D }
                  </td>
                  <td style={{ textAlign: "center" }}>
                     {d.END_D}
                  </td>
                   <td style={{ textAlign: "center" }}>
                     <button type="button" class="ant-btn"
                       onClick={() => {
                         this.setState({ visible5: true, m5: { TYPE: 'E', action: 'edit', ...d }, MACHINE: this.state.data4.filter(r => d.SYSTEM_C === r.SYSTEM_C) });
                       }}><span>แก้ไข</span></button>
                                <button type="button" class="ant-btn" onClick={() => {
                                  let { data5, m5 } = this.state;
                                  data5 = data5.filter(r => r.no !== d.no)

                                  this.setState({ data5: data5 })
                                  setTimeout(() => {
                                    this.putDataLayout5();
                                  }, 50);
                                
                                }}><span>ลบ</span></button>
                  </td>

                  </tr>
                })

              }
                   </table>
                          <span style={{ display: "block", textAlign: "right" }}>
                            <ul className="myNavigation">
                              <li>
                                <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                                  let { data5, m5} = this.state;
                                    data5 = data5.filter(r => r.action !== 'create' && r.TYPE)
  
                                  this.setState({data5: data5 })

                                 
                                 this.setState({ visible5: true, m5: { TYPE: 'E', action: 'create' } , MACHINE: []});
                                }}>
                                  <img src="images/iPencil.png" />
                                  &nbsp;เพิ่ม
                            </button>
                              </li>
                            </ul>
                          </span>
                          <h1>รายละเอียดแผนอนุรักษ์พลังงานด้านความร้อน</h1>

    
                          <table style={{ borderSpacing: "1px 1px" }}>
                                <tr>
                                  <th  rowSpan="2" style={{ width: "70px", textAlign: "center" }}>
                                    ลำดับที่
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                    ชื่อมาตรการ
                                  </th>
                                  <th   colSpan="3" style={{ textAlign: "center" }}>
                                   เป้าหมายผลประหยัด	
                                  </th>
                                  <th  rowSpan="2" style={{ textAlign: "center" }}>
                                    เงินลงทุน (บาท)
                                  </th>
                                  <th   rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
                                 ร้อยละผลประหยัด
                                (คิดเทียบกับการใช้พลังงานรวมของปีฐาน)
                                  </th>
                                  <th colSpan="2"  style={{ width: "100px", textAlign: "center" }}>
                                  ระยะเวลาดำเนินการ
                                  </th>
                                  <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>

                                  </th>
                             </tr>
                      <tr>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          ชนิดเชื้อเพลิง
                      </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        MJ /ปี
                       </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                            บาท/ปี
                       </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                            เริ่มต้น
                       </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                            สิ้นสุด
                       </th>
                    </tr>

                  {
                data5_2.map((d, i) => {
                 return <tr>
                  <td style={{ textAlign: "center" }}>
                     &nbsp;{d.no_}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.MEASURE_TDESC}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.KW}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.KWH}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.BAHT_PER_YR1}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.INSTRUMENT}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.RETURN}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.START_D}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {d.END_D}
                  </td>
                  <td style={{ textAlign: "center" }}>
                     <button type="button" class="ant-btn"
                       onClick={() => {
                         
                 

                         this.setState({ visible5: true, m5: {  TYPE: 'H', action: 'edit',...d }, MACHINE: this.state.data4.filter(r => d.SYSTEM_C === r.SYSTEM_C) });
                                  }}><span>แก้ไข</span></button>
                     <button type="button" class="ant-btn"
                     onClick={()=>{
                      let { data5, m5 } = this.state;
                      data5 = data5.filter(r=>r.no!==d.no)
                      this.setState({data5:data5})
                        setTimeout(() => {
                          this.putDataLayout5();
                        }, 50);
                     }}><span>ลบ</span></button>
                  </td>


                  </tr>
                })
              }
                   </table>
                      <span style={{ display: "block", textAlign: "right" }}>
                            <ul className="myNavigation">
                            <li>
                            <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                                      let { data5, m5} = this.state;
                                    data5 = data5.filter(r => r.action !== 'create' && r.TYPE)
  
                                  this.setState({data5: data5 })

                                  this.setState({ visible5: true, m5: { TYPE: 'H', action: 'create' }, MACHINE: [] });
                              }}>
                              <img src="images/iPencil.png" />
                              &nbsp;เพิ่ม
                            </button>
                          </li>
                    </ul>
                  </span>
                 </div>
                  :null
                }     



                {
  this.props.step === 6 ?
    <div style={{ minHeight: 150, padding: 8 }}>
      {/* <h1>รายละเอียดเครื่องจักรอุปกรณ์ที่มีนัยสำคัญ </h1> */}
      <h1>รายละเอียดแผนอนุรักษ์พลังงานด้านไฟฟ้า </h1>
      <table style={{ borderSpacing: "1px 1px" }}>
        <tr>
          <th rowSpan="2" style={{ width: "70px", textAlign: "center" }}>
            ลำดับที่
                                  </th>
          <th rowSpan="2" style={{ textAlign: "center" }}>
            ชื่อมาตรการ
                                  </th>
          <th colSpan="3" style={{ textAlign: "center" }}>
            เป้าหมายผลประหยัด
                                  </th>
          <th rowSpan="2" style={{ textAlign: "center" }}>
            เงินลงทุน (บาท)
                                  </th>
          <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
            ร้อยละผลประหยัด
           (คิดเทียบกับการใช้พลังงานรวมของปีฐาน)
                                  </th>
          <th colSpan="2" style={{ width: "100px", textAlign: "center" }}>
            ระยะเวลาดำเนินการ
                                  </th>
          <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>

          </th>
        </tr>
        <tr>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            kW
                      </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            kWh/ปี
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            บาท/ปี
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            เริ่มต้น
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            สิ้นสุด
                       </th>
        </tr>
        {
          data6_1.map((d, i) => {
            return <tr>
              <td style={{ textAlign: "center" }}>
                &nbsp;{d.no_}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.MEASURE_TDESC}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.KW}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.KWH}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.BAHT_PER_YR1}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.INSTRUMENT}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.RETURN}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.START_D}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.END_D}
              </td>
              <td style={{ textAlign: "center" }}>
                <button type="button" class="ant-btn"
                  onClick={() => {
                    this.setState({ visible6: true, m6: { TYPE: 'E', action: 'edit', ...d }, MACHINE: [] });
                  }}><span>แก้ไข</span></button>
                <button type="button" class="ant-btn" onClick={() => {
                  let { data6, m6 } = this.state;
                  data6 = data6.filter(r => r.no !== d.no)

                  this.setState({ data6: data6 })
                  setTimeout(() => {
                    this.putDataLayout6();
                  }, 50);

                }}><span>ลบ</span></button>
              </td>

            </tr>
          })

        }
      </table>
      <span style={{ display: "block", textAlign: "right" }}>
        <ul className="myNavigation">
          <li>
            <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
              let { data6, m6 } = this.state;
              data6 = data6.filter(r => r.action !== 'create' && r.TYPE)

              this.setState({ data6: data6 })


              this.setState({ visible6: true, m6: { TYPE: 'E', action: 'create' }, MACHINE: [] });
            }}>
              <img src="images/iPencil.png" />
              &nbsp;เพิ่ม
                            </button>
          </li>
        </ul>
      </span>
      <h1>รายละเอียดแผนอนุรักษ์พลังงานด้านความร้อน</h1>


      <table style={{ borderSpacing: "1px 1px" }}>
        <tr>
          <th rowSpan="2" style={{ width: "70px", textAlign: "center" }}>
            ลำดับที่
                                  </th>
          <th rowSpan="2" style={{ textAlign: "center" }}>
            ชื่อมาตรการ
                                  </th>
          <th colSpan="3" style={{ textAlign: "center" }}>
            เป้าหมายผลประหยัด
                                  </th>
          <th rowSpan="2" style={{ textAlign: "center" }}>
            เงินลงทุน (บาท)
                                  </th>
          <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>
            ร้อยละผลประหยัด
           (คิดเทียบกับการใช้พลังงานรวมของปีฐาน)
                                  </th>
          <th colSpan="2" style={{ width: "100px", textAlign: "center" }}>
            ระยะเวลาดำเนินการ
                                  </th>
          <th rowSpan="2" style={{ width: "100px", textAlign: "center" }}>

          </th>
        </tr>
        <tr>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            ชนิดเชื้อเพลิง
                      </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            MJ /ปี
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            บาท/ปี
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            เริ่มต้น
                       </th>
          <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
            สิ้นสุด
                       </th>
        </tr>

        {
          data6_2.map((d, i) => {
            return <tr>
              <td style={{ textAlign: "center" }}>
                &nbsp;{d.no_}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.MEASURE_TDESC}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.KW}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.KWH}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.BAHT_PER_YR1}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.INSTRUMENT}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.RETURN}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.START_D}
              </td>
              <td style={{ textAlign: "center" }}>
                {d.END_D}
              </td>
              <td style={{ textAlign: "center" }}>
                <button type="button" class="ant-btn"
                  onClick={() => {



                    this.setState({ visible5: true, m6: { TYPE: 'H', action: 'edit', ...d }, MACHINE: [] });
                  }}><span>แก้ไข</span></button>
                <button type="button" class="ant-btn"
                  onClick={() => {
                    let { data6, m6 } = this.state;
                    data6 = data6.filter(r => r.no !== d.no)
                    this.setState({ data6: data6 })
                    setTimeout(() => {
                      this.putDataLayout6();
                    }, 50);
                  }}><span>ลบ</span></button>
              </td>


            </tr>
          })
        }
      </table>
      <span style={{ display: "block", textAlign: "right" }}>
        <ul className="myNavigation">
          <li>
            <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
              let { data6, m6 } = this.state;
              data6 = data6.filter(r => r.action !== 'create' && r.TYPE)

              this.setState({ data6: data6 })

              this.setState({ visible6: true, m6: { TYPE: 'H', action: 'create' }, MACHINE: [] });
            }}>
              <img src="images/iPencil.png" />
              &nbsp;เพิ่ม
                            </button>
          </li>
        </ul>
      </span>
    </div>
    : null
}      


      </div>
    );
  }

  Layout3() {
    let { data1, data2, data3 } = this.state;

    data3 = data3 ? data3 : {};
    return (
      <div>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ขอรับรองว่าข้อความข้างต้นถูกต้อง
          เป็นจริงทุกประการ
        </div>
        <div>
          <table className="MyStyle2">
            <tbody>
              <tr>
                <td style={{ width: "33%", textAlign: "center" }}>
                  {" "}
                  ลงชื่อ
                  ........................................................................
                </td>
                <td style={{ textAlign: "center" }}>
                  ลงชื่อ
                  ........................................................................
                </td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  ลงชื่อ
                  ........................................................................
                </td>
              </tr>
              <tr>
                <td style={{ width: "33%", textAlign: "center" }}>
                  ({data3.AUDIT_1})
                </td>
                <td style={{ textAlign: "center" }}>({data3.AUDIT_3})</td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  ({data3.AUDIT_2})
                </td>
              </tr>
              <tr>
                <td style={{ width: "33%", textAlign: "center" }}>
                  {data3.SIGN_1_D}
                </td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  {data3.SIGN_1_D}
                </td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  {data3.SIGN_1_D}
                </td>
              </tr>
              <tr>
                <td style={{ width: "33%", textAlign: "center" }}>
                  (ผู้ชำนาญการ)
                </td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  (ผู้ช่วยผู้ชำนาญการ)
                </td>
                <td style={{ width: "33%", textAlign: "center" }}>
                  (ผู้ช่วยผู้ชำนาญการ)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  MDLayout2() {
    let { data1, data2, visible2, m2 } = this.state;

    let select = [
      { value: "1", text: "สอดคล้อง" },
      { value: "2", text: "ไม่สอดคล้อง (ร้ายแรง)" },
      { value: "3", text: "ไม่สอดคล้อง (ไม่ร้ายแรง)" }
    ];
    let radio = [
      { value: "1", text: "มี" },
      { value: "", text: "ไม่มี/ไม่พบ" }
    ];
    return (
      <div>
        <Modal
          visible={visible2}
          title="บันทึกข้อมูลการตรวจสอบการจัดการพลังงาน"
          onOk={() => {}}
          onCancel={() => {
            this.setState({ visible2: false, m2: {} });
          }}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState({ visible2: false });
              }}
            >
              ปิด
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={false}
              onClick={() => {
                this.putDataLayout2();
              }}
            >
              บันทึกข้อมูล
            </Button>
          ]}
        >
          <div>
            <form>
              <table>
                <tr>
                  <td>สถานะหลักฐานที่ตรวจพบ</td>
                  <td>
                    <RadioGroup
                      onChange={e => {
                        console.log(e);
                        let { m2 } = this.state;
                        m2.EVIDENCE_FLAG = e.target.value;
                        this.setState({ m2: m2 });
                      }}
                      value={m2.EVIDENCE_FLAG}
                    >
                      {radio.map(r => {
                        return <Radio value={r.value}>{r.text}</Radio>;
                      })}
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td>หลักฐานที่ตรวจพบ</td>
                  <td>
                    <Input
                      name="EVIDENCE_DESC"
                      value={m2.EVIDENCE_DESC}
                      size="80"
                      maxlength="500"
                      onChange={e => {
                        console.log(e);
                        let { m2 } = this.state;
                        m2.EVIDENCE_DESC = e.target.value;
                        this.setState({ m2: m2 });
                      }}
                      style={{ width: "200px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>ความครบถ้วนถูกต้อง</td>
                  <td>
                    <Select
                      name="PASS_FLAG"
                      className=""
                      onChange={e => {
                        console.log(e);
                        let { m2 } = this.state;
                        m2.PASS_FLAG = e;
                        this.setState({ m2: m2 });
                      }}
                      defaultValue=""
                      value={m2.PASS_FLAG}
                    >
                      <Option value="">----กรุณาเลือก----</Option>
                      {select.map(r => {
                        return <Option value={r.value}>{r.text}</Option>;
                      })}
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</td>
                  <td>
                    <TextArea
                      name="NOTE"
                      value={m2.NOTE}
                      size="80"
                      maxlength="500"
                      onChange={e => {
                        console.log(e);
                        let { m2 } = this.state;
                        m2.NOTE = e.target.value;
                        this.setState({ m2: m2 });
                      }}
                      style={{ width: "200px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" align="right">
                    &nbsp;
                  </td>
                </tr>
              </table>
            </form>
          </div>
        </Modal>
      </div>
    );
  }

  TRLayout2() {
    let { data1, data2, visible2, m2 } = this.state;
    let c2 = [];
    let c3 = [];
    let select = [
      { value: "1", text: "สอดคล้อง" },
      { value: "2", text: "ไม่สอดคล้อง (ร้ายแรง)" },
      { value: "3", text: "ไม่สอดคล้อง (ไม่ร้ายแรง)" }
    ];
    let temp = this.getArrayDisable(m2.STEP_C, m2.SEQ);
    if (temp && temp.length > 0) {
    console.log('====================================');
     console.log("temp", temp);
      
      temp = temp[0];
      select = select.filter(r => temp.data.indexOf(r.value) === -1);
      console.log("temp", select, temp.data);

      c2 = temp[2].map(r => {
        return { label: r, value: r };
      });
      c3 = temp[3].map(r => {
        return { label: r, value: r };
      });
    }
    if (select.length === 0) {
      m2.PASS_FLAG = "";
    }

    let radio = [
      { value: "1", text: "มี" },
      { value: "", text: "ไม่มี/ไม่พบ" }
    ];

    //  .filter(r => {
    //    if (m2.EVIDENCE_FLAG !== "") {
    //      return true;
    //    } else if (m2.EVIDENCE_FLAG === "" && r.value !== "1") {
    //      return true;
    //    } else {
    //      return false;
    //    }
    //  })
    return (
      <div>
        <form>
          <table>
            <tr>
              <td>สถานะหลักฐานที่ตรวจพบ</td>
              <td>
                <RadioGroup
                  onChange={e => {
                    console.log(e);
                    let { m2 } = this.state;
                    m2.EVIDENCE_FLAG = e.target.value;
                    m2.PASS_FLAG = "";
                    m2.EXTRA_ARRAY = [];
                    this.setState({ m2: m2 });
                  }}
                  value={m2.EVIDENCE_FLAG}
                >
                  {radio.map(r => {
                    return <Radio value={r.value}>{r.text}</Radio>;
                  })}
                </RadioGroup>
              </td>
            </tr>
            <tr>
              <td>หลักฐานที่ตรวจพบ</td>
              <td>
                <Input
                  name="EVIDENCE_DESC"
                  value={m2.EVIDENCE_DESC}
                  size="80"
                  maxlength="500"
                  onChange={e => {
                    console.log(e);
                    let { m2 } = this.state;
                    m2.EVIDENCE_DESC = e.target.value;

                    this.setState({ m2: m2 });
                  }}
                  style={{ width: "100%" }}
                />
              </td>
            </tr>
            <tr>
              <td>ความครบถ้วนถูกต้อง</td>
              <td>
                <Select
                  name="PASS_FLAG"
                  className=""
                  onChange={e => {
                    console.log(e);
                    let { m2 } = this.state;
                    m2.PASS_FLAG = e;
                    m2.EXTRA_ARRAY = [];
                    this.setState({ m2: m2 });
                  }}
                  value={m2.PASS_FLAG}
                >
                  <Option value="">กรุณาเลือก</Option>
                 
                  {select
                    
                    .map(r => {
                      return <Option value={r.value}>{r.text}</Option>;
                    })}
                </Select>
              </td>
            </tr>
            <tr
              style={{
                display:
                  (m2.PASS_FLAG === "2" && c2.length > 0) ||
                  (m2.PASS_FLAG === "3" && c3.length > 0)
                    ? "contents"
                    : "none"
              }}
            >
              <td> &nbsp;</td>
              <td>
                {m2.PASS_FLAG === "2" ? (
                  <div>
                    <CheckboxGroup
                      options={c2}
                      value={m2.EXTRA_ARRAY}
                      onChange={e => {
                        let { m2 } = this.state;
                        m2.EXTRA_ARRAY = e;
                        this.setState({ m2: m2 });
                      }}
                    />
                  </div>
                ) : null}
                {m2.PASS_FLAG === "3" ? (
                  <div>
                    <CheckboxGroup
                      options={c3}
                      value={m2.EXTRA_ARRAY}
                      onChange={e => {
                        let { m2 } = this.state;
                        m2.EXTRA_ARRAY = e;
                        this.setState({ m2: m2 });
                      }}
                    />
                  </div>
                ) : null}
              </td>
            </tr>
            <tr>
              <td>ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</td>
              <td>
                <TextArea
                  name="NOTE"
                  value={m2.NOTE}
                  size="80"
                  maxlength="500"
                  onChange={e => {
                    console.log(e);
                    let { m2 } = this.state;
                    m2.NOTE = e.target.value;
                    this.setState({ m2: m2 });
                  }}
                  style={{ width: "100%" }}
                />
              </td>
            </tr>
            <tr>
              {/* <td colSpan='2' align='right'>
                &nbsp;
                                    </td> */}
            </tr>
          </table>
        </form>
      </div>
        );
      }
    
    MDLayout4(){
          let { data1, data2, data4Master, visible4,MACHINE, AUDIT_1_ID, AUDIT_2_ID, AUDIT_3_ID,m4 } = this.state
          console.log('====================================');
          console.log("m4",m4);
          console.log('====================================');
          let SYSTEM = _.groupBy(data4Master,'SYSTEM_C')
          let SYSTEM_LIST = [];

          for (const i in SYSTEM) {
              SYSTEM_LIST.push({ SYSTEM_C: i, SYSTEM_NAME: SYSTEM[i][0].SYSTEM_NAME})
          }
          console.log('====================================');
          console.log(SYSTEM_LIST);
          console.log('====================================');
        return <div>
          <Modal
            width={900}
            visible={visible4}
            title="บันทึกเครื่องจักรอุปกรณ์"
            onOk={() => { }}
            onCancel={() => { this.setState({ visible4: false }) }}
            footer={[
              <Button key="back" onClick={() => { this.setState({ visible4: false }) }}>ปิด</Button>,
              <Button key="submit" type="primary" loading={false} onClick={() => {
                    let { data4, m4 } = this.state;
                    if (m4.action === 'create') {
                            data4.push(m4)
                        }else{
                          data4 = data4.map(r=>{
                            if (r.no === m4.no ){
                              r = m4
                            }
                            return r
                          })
                        }
                    this.setState({data4:data4})
                setTimeout(() => {
                  this.putDataLayout4();
                 }, 50);
                }}>
                  บันทึกข้อมูล
                    </Button>,
            ]}
          >
            <table>
              {
                m4 && visible4 ?
                  <tbody>
                    <tr>
                        <td>ระบบ</td>
                <td>
                    <Select defaultValue="" style={{ width: 350 }} onChange={(value) => {
                      let { m4 } = this.state;
                      m4.SYSTEM_C = value;
                      m4.MACHINE_C = '';
                      this.setState({ m4: m4, MACHINE: data4Master.filter(r => value === r.SYSTEM_C)})
                      }} value={m4.SYSTEM_C} >
                      <Option value="">----กรุณาเลือก----</Option>
                      {
                          SYSTEM_LIST.map((r)=>{
                            return <Option value={r.SYSTEM_C} selected="">{r.SYSTEM_NAME}</Option>
                          })
                      }
                    </Select>
                      </td>
                    </tr>
                    <tr>
                        <td>ชื่อเครื่องจักร/อุปกรณ์หลัก</td>
                      <td>
                        <Select defaultValue="" style={{ width: 350 }} onChange={(value) => {
                          let { m4 } = this.state;
                          m4.MACHINE_C = value;
                          this.setState({ m4: m4 })
                          }} value={m4.MACHINE_C} >
                          <Option value="">----กรุณาเลือก----</Option>
                           {
                              MACHINE.map((r)=>{
                                return <Option value={r.MACHINE_C} selected="">{r.MACHINE_NAME}</Option>
                              })
                          }
                        </Select>
                      </td>
                    </tr>
                    <tr>
                    <td>ขนาด</td>
                      <td>
                      <input type="number" value={m4.MACHINE_SIZE} size="40" maxlength="80"
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.MACHINE_SIZE = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                                          class="ant-input hasDatepicker" />
                      </td>
                    </tr>
                    <tr>
                    <td>หน่วย</td>
                      <td>
                            <input type="text" value={m4.UNIT_DESC} size="40" maxlength="80"
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.UNIT_DESC = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                                          class="ant-input hasDatepicker"/>
                      </td>

                    </tr>
                      <tr>
                        <td>จำนวน</td>
                        <td>
                          <input type="number" value={m4.NUM} 
                            onChange={(e) => {
                              let { m4 } = this.state;
                              m4.NUM = e.target.value;
                              this.setState({ m4: m4 })
                            }}
                            class="ant-input hasDatepicker" />
                        </td>

                      </tr>
                        <tr>
                          <td>อายุการใช้งาน (ปี)</td>
                          <td>
                            <input type="number" value={m4.AGE}
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.AGE = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                              class="ant-input hasDatepicker" />
                          </td>

                        </tr>
                         <tr>
                          <td>ชั่วโมงใช้งานเฉลี่ย/ปี</td>
                          <td>
                            <input type="number" value={m4.WORK_HR}
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.WORK_HR = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                              class="ant-input hasDatepicker" />
                          </td>

                        </tr>
                         <tr>
                          <td>ปริมาณการใช้พลังงานไฟฟ้า (กิโลวัตต์-ชั่วโมง/ปี)</td>
                          <td>
                            <input type="number" value={m4.YEAR_USED}
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.YEAR_USED = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                              class="ant-input hasDatepicker" />
                          </td>

                        </tr>
                        <tr>
                          <td>% การใช้พลังงานเทียบกับการใช้พลังงานรวม(รวมทั้งไฟฟ้าและความร้อน)</td>
                          <td>
                            <input type="number" value={m4.PERCENT_USED}
                              onChange={(e) => {
                                let { m4 } = this.state;
                                m4.PERCENT_USED = e.target.value;
                                this.setState({ m4: m4 })
                              }}
                              class="ant-input hasDatepicker" />
                          </td>

                        </tr>
                  </tbody>
                  : null
              }
            </table>
          </Modal>
        </div>
              }
          
    MDLayout5(){
                let { data1, data2, data5, visible5,MACHINE, AUDIT_1_ID, AUDIT_2_ID, AUDIT_3_ID,m5,data5Master } = this.state
        return <div>
                <Modal
                  width={900}
                  visible={visible5}
                  title="แผนอนุรักษ์พลังงาน"
                  onOk={() => { }}
                  onCancel={() => { this.setState({ visible5: false }) }}
                  footer={[
                    <Button key="back" onClick={() => { this.setState({ visible5: false }) }}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={() => {
                      let { data5, m5 } = this.state;
                      if (m5.action === 'create') {
                        data5.push(m5)
                      } else {
                        data5 = data5.map(r => {
                          if (r.no === m5.no) {
                            r = m5
                          }
                          return r
                        })
                      }
                      this.setState({ data5: data5 })
                      setTimeout(() => {
                        this.putDataLayout5();
                      }, 50);
                    }}>
                      บันทึกข้อมูล
                    </Button>,
                  ]}
                >
                  <table>
                    {
                      m5 && visible5 ?
                        <tbody>
                          <tr>
                            <td>ชื่อมาตรการ</td>
                            <td>
                              <Select defaultValue="" style={{ width: 350 }} onChange={(value) => {
                                let { m5 } = this.state;
                                let item_ = data5Master.filter(r=>{
                                  return r.MEASURE_TDESC === value
                                }) 
 
                                if(item_.length > 0){
                                    m5.SYSTEM_C = item_[0].SYSTEM_C;
                                    m5.MEASURE_C = item_[0].MEASURE_C;
                                    m5.MEASURE_TDESC = value
                                }
                              console.log('m5',m5);

                                this.setState({ m5: m5, MACHINE:[] })
                              }} value={m5.MEASURE_TDESC} >
                                <Option value="">----กรุณาเลือก----</Option>
                                {
                                  data5Master.map((r) => {
                                    return <Option value={r.MEASURE_TDESC} selected="">{r.MEASURE_TDESC}</Option>
                                  })
                                }
                              </Select>
                            </td>
                          </tr>
                        <tr>

                                {/* <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          ชนิดเชื้อเพลิง
                      </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        MJ /ปี
                       </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                            บาท/ปี
                       </th>
                        */}
                        {
                            m5.TYPE === 'E' ? <td>kW</td> : <td>ชนิดเชื้อเพลิง</td>
                        }
                          
                            <td>
                             <input type="number" value={m5.KW} size="40" maxlength="80"
                                onChange={(e) => {
                                  let { m5 } = this.state;
                                  m5.KW = e.target.value;
                                  this.setState({ m5: m5 })
                                }}
                                class="ant-input hasDatepicker" />
                            </td>
                          </tr>
                          <tr>
                            {/* <td>kWh/ปี</td> */}
                             {
                              m5.TYPE === 'E' ? <td>kWh/ปี</td> : <td> MJ /ปี</td>
                            }
                            <td>
                              <input type="number" value={m5.KWH} size="40" maxlength="80"
                                onChange={(e) => {
                                  let { m5 } = this.state;
                                  m5.KWH = e.target.value;
                                  this.setState({ m5: m5 })
                                }}
                                class="ant-input hasDatepicker" />
                            </td>
                          </tr>
                          <tr>
                            <td>บาท/ปี</td>
                    {/* {
                      m5.TYPE === 'e' ? <td>บาท</td> : <td>  บาท/ปี</td>
                    } */}
                            <td>
                              <input type="number" value={m5.BAHT_PER_YR1} size="40" maxlength="80"
                                onChange={(e) => {
                                  let { m5 } = this.state;
                                  m5.BAHT_PER_YR1 = e.target.value;
                                  this.setState({ m5: m5 })
                                }}
                                class="ant-input hasDatepicker" />
                            </td>

                          </tr>
                        <tr>
                            <td>เงินลงทุน (บาท)</td>
                            <td>
                              <input type="text" value={m5.INSTRUMENT} size="40" maxlength="80"
                                onChange={(e) => {
                                  let { m5 } = this.state;
                                  m5.INSTRUMENT = e.target.value;
                                  this.setState({ m5: m5 })
                                }}
                                class="ant-input hasDatepicker" />
                            </td>

                          </tr>
                          <tr>
                            <td>ร้อยละผลประหยัด(คิดเทียบกับการใช้พลังงานรวมของปีฐาน)</td>
                             <td>
                              <input type="number" value={m5.RETURN} size="40" maxlength="80"
                                onChange={(e) => {
                                  let { m5 } = this.state;
                                  m5.RETURN = e.target.value;
                                  this.setState({ m5: m5 })
                                }}
                                class="ant-input hasDatepicker" />
                            </td>

                          </tr>
                   
                          <tr>
                            <td>ระยะเวลาดำเนินการ เริ่มต้น</td>
                            <td>
                                  <Datetimepicker name="START_D" value={m5.START_D} onSelect={(value) => {
                                        let { m5 } = this.state;
                                        m5.START_D = value
                                        this.setState({ m5: m5})
                                    }}/>
                            </td>

                          </tr>
                          <tr>
                            <td>ระยะเวลาดำเนินการ สิ้นสุด</td>
                            <td>
                                 <Datetimepicker name="END_D" value={m5.END_D} onSelect={(value) => {
                                      let { m5 } = this.state;
                                      m5.END_D = value
                                      this.setState({ m5: m5})
                                  }}/>
                            </td>

                          </tr>
              
                        </tbody>
                        : null
                    }
                  </table>
                </Modal>
              </div>
    }
MDLayout6(){
             let { data6, visible6, m6,data5Master } = this.state
        return <div>
                <Modal
                  width={900}
                  visible={visible6}
                  title="แผนอนุรักษ์พลังงาน"
                  onOk={() => { }}
                  onCancel={() => { this.setState({ visible6: false }) }}
                  footer={[
                    <Button key="back" onClick={() => { this.setState({ visible6: false }) }}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={() => {
                      let { data6, m6 } = this.state;
                      if (m6.action === 'create') {
                        data6.push(m6)
                      } else {
                        data6 = data6.map(r => {
                          if (r.no === m6.no) {
                            r = m6
                          }
                          return r
                        })
                      }
                      this.setState({ data6: data6 })
                      setTimeout(() => {
                        this.putDataLayout6();
                      }, 50);
                    }}>
                      บันทึกข้อมูล
                    </Button>,
                  ]}
                >
                  <table>
                    {
                      m6 && visible6 ?
                        <tbody>
                          <tr>
                            <td>ชื่อมาตรการ</td>
                            <td>
                              <Select defaultValue="" style={{ width: 350 }} onChange={(value) => {
                                let { m6 } = this.state;
                                let item_ = data5Master.filter(r=>{
                                  return r.MEASURE_TDESC === value
                                })

                                if(item_.length > 0){
                                    m6.SYSTEM_C = item_[0].SYSTEM_C;
                                    m6.MEASURE_C = item_[0].MEASURE_C;
                                    m6.MEASURE_TDESC = value
                                }
                              console.log('m6',m6);

                                this.setState({ m6: m6, MACHINE:[] })
                              }} value={m6.MEASURE_TDESC} >
                                <Option value="">----กรุณาเลือก----</Option>
                                {
                                  data5Master.map((r) => {
                                    return <Option value={r.MEASURE_TDESC} selected="">{r.MEASURE_TDESC}</Option>
                                  })
                                }
                              </Select>
                            </td>
                          </tr>
                        <tr>

                                {/* <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                          ชนิดเชื้อเพลิง
                      </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                        MJ /ปี
                       </th>
                      <th rowSpan="1" style={{ width: "100px", textAlign: "center" }}>
                            บาท/ปี
                       </th>
                        */}
            {
              m6.TYPE === 'E' ? <td>kW</td> : <td>ชนิดเชื้อเพลิง</td>
            }

            <td>
              <input type="number" value={m6.KW} size="40" maxlength="80"
                onChange={(e) => {
                  let { m6 } = this.state;
                  m6.KW = e.target.value;
                  this.setState({ m6: m6 })
                }}
                class="ant-input hasDatepicker" />
            </td>
          </tr>
          <tr>
            {/* <td>kWh/ปี</td> */}
            {
              m6.TYPE === 'E' ? <td>kWh/ปี</td> : <td> MJ /ปี</td>
            }
            <td>
              <input type="number" value={m6.KWH} size="40" maxlength="80"
                onChange={(e) => {
                  let { m6 } = this.state;
                  m6.KWH = e.target.value;
                  this.setState({ m6: m6 })
                }}
                class="ant-input hasDatepicker" />
            </td>
          </tr>
          <tr>
            <td>บาท/ปี</td>
            {/* {
                      m5.TYPE === 'e' ? <td>บาท</td> : <td>  บาท/ปี</td>
                    } */}
            <td>
              <input type="number" value={m6.BAHT_PER_YR1} size="40" maxlength="80"
                onChange={(e) => {
                  let { m6 } = this.state;
                  m6.BAHT_PER_YR1 = e.target.value;
                  this.setState({ m6: m6 })
                }}
                class="ant-input hasDatepicker" />
            </td>

          </tr>
          <tr>
            <td>เงินลงทุน (บาท)</td>
            <td>
              <input type="text" value={m6.INSTRUMENT} size="40" maxlength="80"
                onChange={(e) => {
                  let { m6 } = this.state;
                  m6.INSTRUMENT = e.target.value;
                  this.setState({ m6: m6 })
                }}
                class="ant-input hasDatepicker" />
            </td>

          </tr>
          <tr>
            <td>ร้อยละผลประหยัด(คิดเทียบกับการใช้พลังงานรวมของปีฐาน)</td>
            <td>
              <input type="number" value={m6.RETURN} size="40" maxlength="80"
                onChange={(e) => {
                  let { m6 } = this.state;
                  m6.RETURN = e.target.value;
                  this.setState({ m6: m6 })
                }}
                class="ant-input hasDatepicker" />
            </td>

          </tr>

          <tr>
            <td>ระยะเวลาดำเนินการ เริ่มต้น</td>
            <td>
              <Datetimepicker name="START_D" value={m6.START_D} onSelect={(value) => {
                let { m6 } = this.state;
                m6.START_D = value
                this.setState({ m6: m6 })
              }} />
            </td>

          </tr>
          <tr>
            <td>ระยะเวลาดำเนินการ สิ้นสุด</td>
            <td>
              <Datetimepicker name="END_D" value={m6.END_D} onSelect={(value) => {
                let { m6 } = this.state;
                m6.END_D = value
                this.setState({ m6: m6 })
              }} />
            </td>

          </tr>
              
                        </tbody>
        : null
    }
                  </table>
                </Modal>
              </div >
    }


      render() {
    let { modeLayout1, modeLayout2, modeLayout3, modeLayout4 } = this.state;

    return (
      <div>
        <div className="myForm-2" style={{ minHeight: "530px" }}>
          {/* {this.MDLayout2()} */}
          {this.Layout1()}
          {this.Layout2()}
          {this.Layout3()}

          {this.MDLayout4()}
          {this.MDLayout5()}
          {this.MDLayout6()}
        </div>
      </div>
    );
  }
}



function formatNumber(value) {
  value += '';
  const list = value.split('.');
  const prefix = list[0].charAt(0) === '-' ? '-' : '';
  let num = prefix ? list[0].slice(1) : list[0];
  let result = '';
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`;
}

class NumericInput extends React.Component {
  onChange = (e) => {
    const { value } = e.target;
    const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
    if ((!Number.isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      this.props.onChange(value);
    }
  }

  // '.' at the end or only '-' in the input box.
  onBlur = () => {
    const { value, onBlur, onChange } = this.props;
    console.log('====================================');
    console.log(value, onBlur, onChange);
    console.log('====================================');
    // if (value.charAt(value.length - 1) === '.' || value === '-') {
    //   onChange({ value: value.slice(0, -1) });
    // }
    // if (onBlur) {
    //   onBlur();
    // }
  }

  render() {
    const { value } = this.props;
    const title = value ? (
      <span className="numeric-input-title">
        {value !== '-' ? formatNumber(value) : '-'}
      </span>
    ) : 'กรอกได้เฉพาะตัวเลข';
    return (
      <Tooltip
        trigger={['focus']}
        title={title}
        placement="topLeft"
        overlayClassName="numeric-input"
      >
        <Input
          {...this.props}
          onChange={this.onChange}
          onBlur={this.onBlur}
          placeholder=""
          maxLength={25}
        />
      </Tooltip>
    );
  }
}

export default Xpage6ef04dc09;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef04dc09.js